<template>
  <b-overlay :show="loading">
    <b-container fluid>

      <b-row align-h="center">
        <b-col cols="12" lg="8">

          <b-alert v-if="error" show variant="danger" class="mt-2">
            {{errorMsg}}
          </b-alert>

          <b-row v-if="!error">
            <b-col cols="4">
                <b-img fluid v-bind:src="classObj.photo" />
            </b-col>
            <b-col cols="8" style="margin-left: -20px;">
              <div class="class-title">{{classObj.className}}</div>
              <div v-if="false" class="class-details">
                  {{classObj.name}}
                  <br />
                  Sponsor: {{classObj.companyName}}
                  <br>
                  {{classObj.credits}} CEU ({{ studentData.ceTypeId | prettyCEType }})
                  <br />
                  <span class="red">{{classObj.releaseDate | prettyDateTime}}</span>
              </div>
            </b-col>
          </b-row>

          <b-row v-if="!error && !loading">

            <!-- == ONDEMAND AFFIDAVIT == -->
            <b-col cols="12" class="text-center" v-if="!isLive">
              <b-card
                  title="Verification of Participation Affidavit"
                  tag="article"
                  style="max-width: 100%;"
                  class="mt-2 mb-2"
              >
                  <b-card-text style="text-align:left;">
                      This self-study class is equivalent to {{classObj.credits}} self-study CEU based on the content and duration of this activity per the guidelines of AGD PACE.
                  </b-card-text>

                  <b-card-text style="border:2px solid silver;">
                    <div class="p-3">
                      I attest that I have completed the CE activity in its entirety and am ready to proceed to the CE exam.
                      <b-row class="mt-2">
                        <b-col rows="6">
                          <b-button variant="success" @click="confirmOndemandAttendance(true)">Proceed to Exam</b-button>
                        </b-col>
                        <b-col rows="6">
                          <b-button variant="danger" @click="confirmOndemandAttendance(false)">Return to Classroom</b-button>
                        </b-col>
                      </b-row>
                    </div>
                  </b-card-text>

              </b-card>
            </b-col>

            <!-- == LIVE AFFIDAVIT == -->
            <b-col cols="12" class="text-center" v-if="isLive">
              <div>
              <b-card
                  title="Yes! I attended this live webinar."
                  tag="article"
                  style="max-width: 100%;"
                  class="mt-2 mb-2"
              >
                  <b-card-text style="text-align:left;">
                      Earn live, interactice CEU by confirming your attendance at this live webinar.
                  </b-card-text>

                  <b-overlay :show="savingYes" rounded="sm">
                      <b-button variant="success" @click="confirmLiveAttendance(true)">Yes I Attended</b-button>
                  </b-overlay>
              </b-card>
              </div>

              <div>
              <b-card
                  title="No, I was unable to attend this webinar."
                  tag="article"
                  style="max-width: 100%;"
                  class="mb-2"
              >
                  <b-card-text style="text-align:left;">
                      If you were not able to attend this live webinar you can still earn self-study credit after watching the playback and passing the exam.
                  </b-card-text>

                  <b-overlay :show="savingNo" rounded="sm">
                      <b-button variant="secondary" @click="confirmLiveAttendance(false)">No, I Did Not Attend</b-button>
                  </b-overlay>
              </b-card>
              </div>
            </b-col>

          </b-row>

        </b-col>
      </b-row>
    </b-container>
  </b-overlay>
</template>

<script>
/* eslint-disable */
'use strict'

import service from "@/service/service";
import utils from "@/utils/utils";

var data = {
  debug: false,
  error: false,
  errorMsg: null,
  loading: true,
  msg: "Classroom",
  blurb: "Classroom blurb.",
  classObj: {status: false, zoomCode: null},
  studentData: {status: false},
  studentHash: "",
  classHash: "",
  savingYes: false,
  savingNo: false
}

export default {
  name: "Classroom",
  data() {
    return data;
  },
  props: {
    // route set to use props mapped to url parameters
    c: {
      type: String,
      required: true,
      default: ""
    }
  },
  computed: {
    description: function() {
      return utils.nl2br(this.classObj.description);
    },
    isLive: function() {
      // Indicates student started live webinar.
      return this.studentData.studentStarted
    }
  },
  methods: {
    gotoClass() {
      this.$router.push(`/classroom/${this.classHash}`)
    },
    gotoEval() {
      this.$router.push(`/eval/${this.classHash}`)
    },
    confirmOndemandAttendance(attended) {
      // TBD - save timestamped response in gradebook?
      if (attended) {
        this.gotoEval()
      }
      else {
        this.gotoClass()
      }
    },
    confirmLiveAttendance(attended) {
      // console.log(`Attendance: ${attended}`)

      this.savingYes = attended
      this.savingNo = !attended

      let data = {
          c: this.classHash,
          s: this.studentHash,
          attended: attended
      }
      service
        .saveAffidavit(data)
        .then(
          (res => {
            // console.log(`back from saveAffidavit!`)
            if (this.debug) console.log(res)
            if (res.status) {
              this.gotoEval()
            }
            else {
              // status returns false when student did not reserve seat
              this.error = true
              this.errorMsg = 'Error recording response. Try again later.'
            }
          }).bind(this)
        )
        .finally(e => {
          this.saving = false;
          if (this.debug) console.log(`finally...`)
        })
        .catch(e => {
          this.error = true
          this.errorMsg = 'System error recording response. Try again later.'
          console.log(e)
        })
    }
  },
  created() {
    this.loading = true
    this.classHash = this.c || this.$route.query.c || this.$root.getClassHash() || null
    this.studentHash = this.$root.getToken();
    if (this.classHash) {
      service
        .getClass(this.classHash, this.studentHash)
        .then(
          (data => {
            if (this.debug) console.log(data)
            if (data.status) {
              this.classObj = data.classObj
              if (data.studentData.status) { // Gradebook data available?
                this.studentData = data.studentData
                if (this.studentData.classViewCount === 0) {
                  alert('Please view class before taking exam.')
                  this.gotoClass()
                }
                else if (this.studentData.examTaken) {
                    alert('Exam completed.  Returning to classroom.')
                    this.gotoClass()
                }
                else if ( this.studentData.studentEnded ) {
                  // Live class affidavit completed (studentEnded <> 0).
                  this.gotoEval()
                }
              }
              else {
                // Added 6/13/2023 - ask student to return to classroom to view class.
                // Student attending a live class will always have a gradebook record.
                alert('Please view class before taking exam.')
                this.gotoClass()
              }
            }
            else {
              this.error = true
              this.errorMsg = 'Data error.  Try again later.'
            }
          }).bind(this)
        )
        .finally(e => {
          this.loading = false
        })
        .catch(e => {
          this.error = true
          this.errorMsg = 'System Error.  Try again later.'
          console.log(e);
        })
    }
    else {
      // route should prevent this option
      this.$router.push("/exams")   // CE in progress
      this.error = true
      this.errorMsg = 'No class selected.'
    }
    // this.error = this.$root.getClassId() === 0;
  },
  mounted () {
    if (this.debug) console.log('mounted')
  },
  beforeDestroy() {
    this.classObj = {status: false, zoomCode: null}
    this.studentData = {status: false}
    this.savingYes = false
    this.savingNo = false
    this.loading = true
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.card-title {
  font-size: 1.09rem;
  font-weight: bold;
}
.txt-webinar-begins {
  color: black;
  font-weight: bold;
  font-size: 1.25rem;
}
.txt-webinar-countdown {
  color: red;
  font-weight: bold;
  font-size: 1.25rem;
}
</style>



// WEBPACK FOOTER //
// src/components/ClassroomAffidavit.vue